import {createContext, useReducer} from 'react'

// creating context
export const ClientsContext = createContext()

// reducer function
export const clientsReducer = (state, action) => {

    // switching through action
    switch(action.type){
        // this will set the current clients as the current state
        case "SET_CLIENTS":
            return {
                clients: action.payload
            }
        // This will set the current client state as the current client state + the new client we pass in     
        case "CREATE_CLIENT":
            return{
                clients: [action.payload, ...state.clients]
            }
        // This will filter through the current state of clients, and return all of them except the one we pass in (the one we are deleting)     
        case "DELETE_CLIENT":
            return{
                clients: state.clients.filter((client) => client._id !== action.payload._id)
            }
        // otherwise we just return the state     
        default:
            return state            
    }
}

// this provides the context
export const ClientsContextProvider = ({children}) => {

    // this is our state + reducer function, which we will pass down as a value to our children below 
    const [state, dispatch] = useReducer(clientsReducer, {
        clients: null
    })

    return (

        <ClientsContext.Provider value={{...state,dispatch}}>
            {children}
        </ClientsContext.Provider>
    )
}

